import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import LECollectionFeed from "./routes/LECollectionFeedPage";
import UnitFeed from "./routes/UnitFeedPage";
import LEFeed from "./routes/LEFeedPage";
import WorksheetFeed from "./routes/WorksheetFeedPage";
import MockExamFeed from "./routes/MockExamFeedPage";
import QuestionFeed from "./routes/QuestionsFeedPage";
export default store => {
  return {
    path: "feed-section",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      LECollectionFeed(store),
      LEFeed(store),
      UnitFeed(store),
      WorksheetFeed(store),
      MockExamFeed(store),
      QuestionFeed(store),
    ],
  };
};
